export default "/kiban/_next/static/images/top_matteBlack-7039568bfc66cb88bdf22802f77c53ce.png";